<template>
  <article class="media hand" @click="selData()">
    <div class="media-left">
      <div class="has-background-primary has-text-white has-text-centered numero">E</div>
    </div>
    <div class="media-content">
      <span v-bind:class="active(fila,selcolumn.columnnit)">
        <b>Cliente:</b>
      </span>
      <span v-bind:class="active(fila,selcolumn.columnnit)">
        <b>{{nombreNit}}</b>
      </span>
      <span
        class="textcuenta fontMono"
        v-bind:class="active(fila,selcolumn.columnnit)"
      >{{codigoNit | textnumber(0)}}{{codigoNit | dverif()}},</span>
      <span v-bind:class="active(fila,selcolumn.columnvendedor)">Vendedor: {{vendedor}},</span>
      <strong :class="active(fila,selcolumn.columnfpago)">Forma de pago: {{fpago}}.</strong>
      <br />
      <span :class="active(fila,selcolumn.columnbodega)">Bodega:</span>
      <span class="gris" :class="active(fila,selcolumn.columnbodega,'bodega')">{{bodega}},</span>
      <span :class="active(fila,selcolumn.columnlprecio)">Lista de precios:</span>
      <span class="gris" :class="active(fila,selcolumn.columnlprecio)">{{lprecios}}</span>,
      <span :class="active(fila,selcolumn.columnccosto)">
        Centro de costos:
      </span>
      <span class="gris" :class="active(fila,selcolumn.columnccosto)">{{ccosto}}</span>
      
    </div>
  </article>
</template>

<script>
export default {
  props: {
    encabezado: {
      type: Object
    },
    fila: Number,
    columna: Number,
    selection: Array,
    selcolumn: Object
  },
  methods: {
    selData() {
      console.log('le dio click');
      this.$emit("columna", 1);
      this.$emit("fila", -1);
    },
    active(f, c) {
      if (c === this.columna && f === -1) {
        return {
          "is-select": true
        };
      } else {
        if (!this.encabezado[this.selection[c - 1].valida]) {
          return {
            "is-error": true
          };
        }
      }
    }
  },
  computed: {
    codigoNit() {
      if (this.encabezado.nit) {
        return this.encabezado.nit;
      } else {
        return "xxx.xxx.xxx-x";
      }
    },
    nombreNit() {
      if (this.encabezado.nombreNit) {
        return this.encabezado.nombreNit;
      } else {
        return "Nombre del tercero, empresa o persona";
      }
    },
    vendedor() {
      if (this.encabezado.nombrevendedor) {
        return `${this.encabezado.nvendedor} - ${this.encabezado.nombrevendedor}`;
      } else {
        return "Sin vendedor";
      }
    },
    bodega() {
      if (this.encabezado.nombrebodega) {
        return `${this.encabezado.nbodega} - ${this.encabezado.nombrebodega}`;
      } else {
        return "No encontrada";
      }
    },
    lprecios(){
      if (this.encabezado.nombrelprecios) {
        return `${this.encabezado.lprecios} - ${this.encabezado.nombrelprecios}`;
      } else {
        return "No encontrada";
      }
    },
    ccosto(){
      if (this.encabezado.nombreCcostos) {
        return `${this.encabezado.nccostos} - ${this.encabezado.nombreCcostos}`;
      } else {
        return "No encontrado";
      }
    },
    fpago(){
      if (this.encabezado.nombrefpago) {
        return `${this.encabezado.nombrefpago}`;
      } else {
        return "No encontrado";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.numero {
  font-size: 14px;
  padding-top: 3px;
  padding-bottom: 3px;
  width: 27px;
  border-radius: 20px;
}
.gris {
  color: #7a7a7a;
}
.textcuenta {
  font-weight: bold;
}
.is-select {
  color: #00d1b2;
  font-size: 23px;
}
.is-error {
  color: #ff3860;
}
</style>


// WEBPACK FOOTER //
// src/components/registrar/Viewencabezado.vue